import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { PitchFormData } from "../../../components/Models/PitchFormData";

type UpdateUserDto = Partial<PitchFormData>;

interface ApiResponse<T> {
  message: string;
  data: T;
}

export const useSavePitch = (
  options?: UseMutationOptions<
    ApiResponse<PitchFormData>,
    unknown,
    PitchFormData | UpdateUserDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<PitchFormData> | FormData) => {
      const isFormData = data instanceof FormData;

      // Determine if it's an update or create operation
      const hasId = isFormData
        ? data.get("id") ?? null
        : (data as Partial<PitchFormData>).id ?? null;

      // Set headers for FormData
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/Pitch/UpdatePitch`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Pitch/CreatePitch"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
